import { mainContainer } from '../../main.module';
import { ProfileInterface, ProfileService } from './profile.service';

export const Profile = mainContainer.get<ProfileInterface>(ProfileService);

export { ProfileUrlSettings, DefaultUrlSettingType } from './profile.service';
